import api from "./api";

export const getPandits = (cityId = "") => {

  return api.get(
    "/api/v1/pandit/",
    {
      params: {
        loc: cityId || "",
      },
    }
  );
};